import { memo, useCallback } from "react";
import type { FormEvent, ChangeEvent } from "react";
import "./ChattingInput.scss";

type ChattingInputProps = {
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onSubmit: (e: FormEvent) => void;
    placeholder?: string;
    disabled?: boolean;
};

export default memo(function ChattingInput({
    value,
    onChange,
    onSubmit,
    placeholder = "",
    disabled = false,
}: ChattingInputProps) {
    const handleFocus = useCallback(() => {
        // Wait for keyboard to appear, then scroll chat messages to bottom
        setTimeout(() => {
            const scrollArea = document.querySelector('.ChatArea .MessagesContainer');
            scrollArea?.scrollTo({ top: scrollArea.scrollHeight, behavior: 'smooth' });
        }, 300);
    }, []);

    return (<>
        <div className="ChattingInputSpacer" />
        <form className="ChattingInput" onSubmit={(e) => {
            e.preventDefault();
            onSubmit(e);
        }}>
            <div className="Wrapper">
                <input
                    type="text"
                    autoFocus
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    className="Field"
                    onFocus={handleFocus}
                />
                <button
                    type="submit"
                    disabled={disabled || !value.trim()}
                    className="SendButton"
                    aria-label="Send"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M18 10L4 3L6 10L4 17L18 10Z"
                            fill="currentColor"
                        />
                    </svg>
                </button>
            </div>
        </form>
    </>);
});
